'use client';

/**
 * @module
 * @category Component
 */

import 'BomdisoftComponents/social/share-styles.css';
import { FacebookIcon, ShareIcon, XIcon } from 'BomdisoftComponents/icons/index';
import { Menu, MenuItem } from 'BomdisoftComponents/menu/index';
import { useSnackbar } from 'BomdisoftComponents/notifications/snackbars/store';
import { readFacebook, toXShareUrl } from 'BomdisoftComponents/social/delegate';
import { Tooltip } from 'BomdisoftComponents/tooltip/index';
import { getLanguageFromLocale, shareActionT, shared, shareOnBrandT, shareOnSocialMediaT, tryAgain } from '@bomdisoft/translations';
import { useParams } from 'next/navigation';
import { useId, useRef, useState } from 'react';

export type SocialMediaShareProps = Record<string, never>;

export const SocialMediaShare = (_props: SocialMediaShareProps) => {
  const params = useParams();
  const language = getLanguageFromLocale(params?.lang as string) ?? 'english';
  const { enqueueSnackbar } = useSnackbar();

  const triggerRef = useRef<HTMLButtonElement>(null);
  const menuId = useId();
  const [open, setOpen] = useState(false);

  const shareOnFacebook = () => {
    setOpen(false);
    readFacebook(window)?.ui(
      {
        display: 'popup',
        href: typeof window != 'undefined' ? window.location.href : '',
        method: 'share',
      },
      response => {
        if (response && !response.error_message) enqueueSnackbar(shared[language], { variant: 'success' });
        else enqueueSnackbar(tryAgain[language], { variant: 'error' });
      },
    );
  };

  const shareOnX = () => {
    setOpen(false);
    const shareMessage = `Check out this tip from Bomdisoft \n\n ${typeof window != 'undefined' ? window.location.href : ''}`;
    window.open(toXShareUrl(shareMessage), '_blank', 'noopener,noreferrer');
  };

  return (
    <>
      <Tooltip placement='top' title={shareActionT[language]}>
        <button aria-controls={menuId} aria-haspopup='true' aria-label={shareOnSocialMediaT[language]} className='bomdisoft-social-share-trigger' onClick={() => setOpen(true)} ref={triggerRef} type='button'>
          <ShareIcon size={20} />
        </button>
      </Tooltip>
      <Menu anchorRef={triggerRef} id={menuId} onClose={() => setOpen(false)} open={open} testId='share-menu'>
        <MenuItem onClick={shareOnFacebook} testId='share-facebook'>
          <FacebookIcon className='bomdisoft-social-share-facebook' size={20} />
          {shareOnBrandT[language].replace('{name}', 'Facebook')}
        </MenuItem>
        <MenuItem onClick={shareOnX} testId='share-x'>
          <XIcon className='bomdisoft-social-share-x' size={20} />
          {shareOnBrandT[language].replace('{name}', 'X')}
        </MenuItem>
      </Menu>
    </>
  );
};
